// The title a workout card shows. VIDEO-type ('V') items can be saved without a
// title; they read as "Video", matching Build's day list.
const getWorkoutItemTitle = (item) => {
  if (item?.type === 'V' && !item?.title?.trim()) return 'Video';
  return item?.title;
};

export default getWorkoutItemTitle;
